import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/Home';
import Header from './components/Header';
import HeaderLocked from './components/HeaderLocked';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { UserProvider, UserContext } from './components/UserContext';
import StoryForm from './components/StoryForm/StoryForm';
import './App.css';
import PublicBooksPage from './components/PublikBooksPage';
import ProductsDashboard from './components/ProductsDashboard';
import AffiliatePromoCode from './components/AffiliatePromoCode';
import PrelaunchWrapper from './components/PrelaunchWrapper';
import PrivacyPage from './components/PrivacyPolicy';
import CookieBanner from "./components/CookieBanner";
import api from './api/apiClient'; 
import PixelPageView from "./components/PixelPageView";
import PaymentSuccess from './components/PaymentSuccess';
import MaintenanceNotice from './components/MaintenanceNotice';

const MAINTENANCE_MODE = false;

function AppRoutes() {
  const {
    loading,
    isLoginModalOpen,
    setIsLoginModalOpen,
    handleSuccessfulLogin,
    isPrelaunch,
  } = useContext(UserContext);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      {/* Spåra sidvisningar */}
      <PixelPageView />

      <div className="App">
        {isPrelaunch ? (
          <HeaderLocked />
        ) : (
          <Header openLoginModal={() => setIsLoginModalOpen(true)} />
        )}

        <main className="main-content">
          <PrelaunchWrapper isPrelaunch={isPrelaunch}>
            <Routes>
              <Route path="/" element={<HomePage />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
             <Route
                path="/skapa"
                element={
                  MAINTENANCE_MODE ? (
                    <MaintenanceNotice />
                  ) : (
                    isPrelaunch ? (
                      <StoryForm />
                    ) : (
                      <ProtectedRoute>
                        <StoryForm />
                      </ProtectedRoute>
                    )
                  )
                }
              />
              <Route path="/integritetspolicy" element={<PrivacyPage />} />
              <Route
                path="/dashboard"
                element={
                  isPrelaunch ? (
                    <Dashboard />
                  ) : (
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  )
                }
              />
              <Route path="/affiliate" element={<AffiliatePromoCode />} />
              <Route
                path="/produkter"
                element={
                  <ProtectedRoute>
                    <ProductsDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/publika" element={<PublicBooksPage />} />
            </Routes>
          </PrelaunchWrapper>
        </main>

        <Footer />
        <CookieBanner />

        <AuthModal
          isOpen={isLoginModalOpen}
          closeModal={() => setIsLoginModalOpen(false)}
          onSuccessfulLogin={handleSuccessfulLogin}
        />
      </div>
    </Router>
  );
}

function App() {
  const handleFormSubmit = async (formData) => {
    try {
      const response = await api.post('/create-script', formData);
      return response.data;
    } catch (error) {
      console.error('Fel vid form submission:', error);
      throw error;
    }
  };

  return (
    <UserProvider handleFormSubmit={handleFormSubmit}>
      <AppRoutes />
    </UserProvider>
  );
}

export default App;
